module.exports = __webpack_public_path__ + "img/sashimisakemaki.29b97800.png";